module.exports = __webpack_public_path__ + "img/img_promotion_bnr_main_kt.6aa7b749.png";